import { IconSet } from '@postscript/components';
import { useMemo } from 'react';

import { NavMenuItem } from 'components/navigation/NavMenu';

export const useIntegrationsMenuItems = () => {
  return useMemo(
    (): NavMenuItem[] => [
      {
        id: 'integrations',
        label: 'Integrations',
        icon: IconSet.Apps,
        isLoading: false,
        ariaLabelledBy: 'nav-integrations-title',
        subMenu: [
          {
            link: '/integrations',
            label: 'All',
            id: 'integrations-all',
            entitlementKey: 'integrations::browse',
          },
          {
            link: '/fondue',
            label: 'Fondue',
            id: 'fondue',
            tag: { content: 'New' },
            entitlementKey: 'integrations::fondue::setup',
          },
        ],
      },
    ],
    [],
  );
};
